<template>
  <div
    class="form-detail"
    v-if="item.merchantBusinessAreas && item.merchantBusinessAreas.length > 0"
  >
    <h1>Điểm chấp nhận thanh toán</h1>
    <div class="table-responsive">
      <table class="table table-hover table-bordered">
        <thead class="thead-light">
          <tr>
            <th scope="col" class="text-left">Tên điểm</th>
            <th scope="col" class="text-left">Địa chỉ</th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in item.merchantBusinessAreas" :key="index">
          <tr class="table-row">
            <td class="text-left">{{ item.areaName }}</td>
            <td class="text-left">
              {{ item.areaAddress }}
              <span v-show="item?.areaWard"> - {{ item?.areaWard }}</span>
              <span v-show="item.areaDistrict"> - {{ item.areaDistrict }}</span>
              <span v-show="item.areaCity"> - {{ item.areaCity }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
  }
</script>
